import { FC } from "react";
import { Skeleton } from "@chakra-ui/react";
import {
  ArticleCardType,
  DimensionProps,
  articleCardStyleProps,
} from "./utils";

type SkeletonArticleCardProps = {
  [key in ArticleCardType]: {
    height: DimensionProps;
    width: DimensionProps;
  };
};

export const skeletonCardProps = (): SkeletonArticleCardProps => {
  return Object.keys(articleCardStyleProps).reduce((acc, key) => {
    const { height, width } = articleCardStyleProps[key as ArticleCardType];
    acc[key as ArticleCardType] = {
      height,
      width,
    };
    return acc;
  }, {} as SkeletonArticleCardProps);
};

interface Props {
  type?: ArticleCardType;
}

export const SkeletonArticleCard: FC<Props> = ({ type = "narrow" }) => {
  const { height, width } = skeletonCardProps()[type];

  return (
    <Skeleton
      endColor="newDarkGreen.300"
      height={height}
      m={3}
      p={4}
      rounded="md"
      startColor="th.signatureGreen"
      width={width}
    />
  );
};
